import React from 'react';
import {
  Description,
  Wrapper,
  Elements,
  Subtext,
  Content
} from './styled';

interface Props {
  label?: string;
  componentRight?: React.ReactNode;
  className?: string;
  subtext?: string;
}

export const FieldForm: React.FC<Props> = ({
  children,
  label,
  componentRight,
  className,
  subtext
}) => (
  <Wrapper className={className}>
    <Elements>
      <Content>
        <Description>{label}</Description>
        { subtext && <Subtext>{subtext}</Subtext> }
      </Content>
      {componentRight}
    </Elements>
    {children}
  </Wrapper>
);
